// extracted by mini-css-extract-plugin
module.exports = {"label":"FormItem_label__2kSLL","noMarginTop":"FormItem_noMarginTop__GEllz","input":"FormItem_input__2jQiO","inputPassword":"FormItem_inputPassword__3uFOA"};